export const ThreeBand = () => (
  <span className="three-band" data-testid="three-band-mark" aria-hidden="true">
    <span className="b1" />
    <span className="b2" />
    <span className="b3" />
  </span>
);
